import { render, staticRenderFns } from "./Bdxz.vue?vue&type=template&id=0d9e820c&scoped=true"
import script from "./Bdxz.vue?vue&type=script&lang=js"
export * from "./Bdxz.vue?vue&type=script&lang=js"
import style0 from "./Bdxz.vue?vue&type=style&index=0&id=0d9e820c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e820c",
  null
  
)

export default component.exports